var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_31664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0235 50.6293C22.1055 51.5793 23.2225 52.5595 24.3715 53.5758L24.3953 53.5967L28.2176 56.8983C28.7297 57.3408 29.3653 57.5619 30.0009 57.5619C30.6365 57.5619 31.2723 57.3406 31.7844 56.8983L35.6059 53.5967L35.6296 53.5759C43.1962 46.8843 48.8692 41.7614 52.9736 36.765C57.7673 30.9295 60.0002 25.6533 60.0002 20.1605C60.0002 10.2227 52.2158 2.43823 42.2783 2.43823C37.8119 2.43823 33.3987 4.12005 30.0009 7.03542C26.6022 4.11987 22.189 2.43823 17.7224 2.43823C7.78461 2.43805 0 10.2227 0 20.1603C0 32.1729 8.36364 39.5152 21.0235 50.6293ZM19.0885 24.5445H26.3627V17.27H33.6372V24.5445H40.9115V31.8188H33.6372V39.093H26.3627V31.8188H19.0885V24.5445Z",
    fill: "#8A49D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_31664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.ae34a4ddf43f4221825cb57cda0cfc87.svg";
export { ForwardRef as ReactComponent };